import React from 'react';
import ReactDOM from 'react-dom';

import { CustomerFields, PaymentButtonState } from '../types/config';

const mountedContainers = new WeakSet<HTMLElement>();

export interface WidgetAPI {
    submitPayment: () => Promise<void>;
    getPaymentState: () => PaymentButtonState;
    updateCustomerFields: (fields: CustomerFields) => void;
}

export interface ReactRootInstance {
    destroy: () => void;
    getAPI: () => WidgetAPI | null;
}

const apiRegistry = new WeakMap<HTMLElement, WidgetAPI>();

export const registerWidgetAPI = (
    api: WidgetAPI,
    container: HTMLElement
): void => {
    apiRegistry.set(container, api);
};

export const unregisterWidgetAPI = (container: HTMLElement): void => {
    apiRegistry.delete(container);
};

export const mountReactRoot = (
    container: HTMLElement,
    component: React.ReactElement
): ReactRootInstance => {
    if (mountedContainers.has(container)) {
        ReactDOM.unmountComponentAtNode(container);
        mountedContainers.delete(container);
    }

    unregisterWidgetAPI(container);

    ReactDOM.render(component, container);
    mountedContainers.add(container);

    return {
        destroy: () => {
            if (mountedContainers.has(container)) {
                ReactDOM.unmountComponentAtNode(container);
                mountedContainers.delete(container);
                unregisterWidgetAPI(container);
            }
        },
        getAPI: () => apiRegistry.get(container) ?? null
    };
};
